import { render, staticRenderFns } from "./InstallationModal.vue?vue&type=template&id=187ce6a4&scoped=true"
import script from "./InstallationModal.vue?vue&type=script&lang=js"
export * from "./InstallationModal.vue?vue&type=script&lang=js"
import style0 from "./InstallationModal.vue?vue&type=style&index=0&id=187ce6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ce6a4",
  null
  
)

export default component.exports